<template>
<div>
<div class="contenttopbar grid px-3 mt-1">

<div class="col-9 md:col-8">
<h3 class="text-primary mb-3 mt-3 font-medium">{{$store.state.languages.lang_phrases.marka_projeleri}}</h3>
</div>

<div class="col-3 md:col-4">
<div class="flex align-items-center justify-content-end">

<div class="hide_on_mobile "><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2 mr-2" :label="$store.state.languages.lang_phrases.yeni_paket_ekle" icon="pi pi-briefcase" @click="addNewBundle" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2 mr-2" icon="pi pi-briefcase" @click="addNewBundle" /></div>

<div class="hide_on_mobile "><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" @click="addNew" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" icon="pi pi-plus" @click="addNew" /></div>


</div>
</div>
</div>  




<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<template v-if="projects.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>

</div>
</template>
<template v-else>
  <div class="mt-4">




<template v-if="bundles.length">
<h3 class="text-primary font-bold">{{$store.state.languages.lang_phrases.proje_paketleri}}</h3>

<ContentTable :data="bundles" :columns="bundle_columns" identifier_row_name="bundle_id" routename="BrandProjectBundle" deleteobjectname="project_bundle" @dataDeleted="getData"></ContentTable>
<br/>
<h3 class="text-primary font-bold">{{$store.state.languages.lang_phrases.projeler}}</h3>
</template>


<ContentTable :data="projects" :columns="columns" routename="Project"  deleteobjectname="project" @dataDeleted="getData"  :sortable="true" @rowsReorders="listupdated" ></ContentTable>


</div>
</template>






</template>



</div>
</template>

<script>
export default {

  name: 'BrandProjects',

  data () {
    return {
    	projects:[],
      bundles:[],
    	loading:true,
      bundle_columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
        multilingual:true,
      },
      {
        type:"text",
        field:"projects.length",
        header:"projeler",
        hide_on_mobile:false,
        multilingual:false,
      },
      ],
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        multilingual:true,
        with_route:true,
        hide_on_mobile:false,
      },
      ]
    }
  },
   mounted()
  {
  	this.getData()
  },
  methods:{
    addNew()
    {
      this.$router.push({ name: "CreateBrandProject"})
    },
    addNewBundle()
    {
      this.$router.push({ name: "CreateProjectBundle"})
    },
  	async getData()
    {
      if(this.$store.state.auth.userroles.includes("admin"))
      {
        this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
        this.bundles = await this.generalApiGetWithoutLoader("brand/project_bundles/"+this.$route.params.id)
      }

      if(this.$store.state.auth.userroles.includes("brand"))
      {
        this.projects = await this.generalApiGetWithoutLoader("brand_contact_projects/"+this.$route.params.id)
      }
        
        console.log(this.projects)
        console.log(this.bundles)
        this.loading = await false
    },    
    listupdated(data)  
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append('list', JSON.stringify(data));
      this.generalSubmission(formdata,"project/reorder/"+this.$route.params.id,this.afterlistupdated)
    },
    afterlistupdated(response)
    {
      console.log(response.data)
      this.projects = response.data
    },
  }
}
</script>

<style lang="css" scoped>
</style>